<!-- Footer Area-->
<footer class="footer-area ptb-70">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="footer-widget">
          <div class="logo">
            <img
              src="assets/img/transperant-logo.png"
              alt="logo"
              class="footer-logo"
            />
          </div>
          <p><b>TVT Logistics India</b></p>
          <p><b>The Vantage Tradelink</b></p>
          <p><b>The Vantage Tradelink LLC</b></p>
          <p><b>TVT Logistics (EA) LTD</b></p>
          <div class="row certificate-container">
            <div class="col">
              <img
                src="assets/img/mto.jpg"
                class="certificate-logo"
                alt="logo"
              />
            </div>
            <div class="col">
              <img
                src="assets/img/aon.jpg"
                class="certificate-logo"
                alt="logo"
              />
            </div>
          </div>

          <ul class="footer-socials">
            <li>
              <a href="#" target="_blank"><i class="bx bxl-facebook"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i class="bx bxl-twitter"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i class="bx bxl-instagram"></i></a>
            </li>
          </ul>
        </div>
      </div>

      <!-- <div class="col">
        <div class="footer-widget pl-50">
          <h3>Our Services</h3>

          <ul class="footer-text">
            <li>
              <a routerLink="/services" fragment="sea">Sea/ Air Freight</a>
            </li>

            <li>
              <a routerLink="/services" fragment="break-bulk">Break Bulk</a>
            </li>
            <li>
              <a routerLink="/services" fragment="surface-transportation"
                >Surface Transportation</a
              >
            </li>
          </ul>
        </div>
      </div> -->

      <div class="col">
        <div class="footer-widget">
          <div class="footer-widget-heading">
            <img
              src="assets/img/india-flag-icon.svg"
              alt="logo"
              class="flag-icon"
            />
            <h3>India Office</h3>
          </div>

          <ul class="info-list">
            <li>
              <i class="bx bxs-location-plus"></i>201, Abhijeet-I Opp: Kolkata
              Motors, Mithakhali Six Road, Ahmedabad-380009. Gujarat. India.
            </li>
            <li>
              <i class="bx bxs-envelope"></i>
              <a href="mailto:lcl@thevantagetradelink.in"
                >lcl@thevantagetradelink.in</a
              >
              <br />
              <a href="mailto:lcl1@thevantagetradelink.in">
                lcl1@thevantagetradelink.in</a
              >
            </li>
            <li>
              <i class="bx bxs-phone"></i>
              <a>+91-7948970012 / 13 / 15</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col">
        <div class="footer-widget">
          <div class="footer-widget-heading">
            <img
              src="assets/img/united-states-flag-icon.svg"
              alt="logo"
              class="flag-icon"
            />
            <h3>USA Office</h3>
          </div>

          <ul class="info-list">
            <li>
              <i class="bx bxs-location-plus"></i>30 N Gould St Ste R, Sheridan,
              Wyoming 82801, USA.
            </li>
            <li>
              <i class="bx bxs-envelope"></i>
              <a href="mailto:importusa@thevantagetradelink.in"
                >importusa@thevantagetradelink.in</a
              >
              <br />
              <a href="mailto:sales1@thevantagetradelink.in">
                sales1@thevantagetradelink.in</a
              >
            </li>
            <li>
              <i class="bx bxs-phone"></i>

              <a>+001- 201 366 2633 / 470 646 5560</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col">
        <div class="footer-widget">
          <div class="footer-widget-heading">
            <img
              src="assets/img/uganda-flag-icon.svg"
              alt="logo"
              class="flag-icon"
            />
            <h3>Uganda Office</h3>
          </div>

          <ul class="info-list">
            <li>
              <i class="bx bxs-location-plus"></i>Plot 1787, Block 82 Kyadondo,
              Bombo Road, Matugga, Kampala, Uganda.
            </li>
            <li>
              <i class="bx bxs-envelope"></i>
              <a href="mailto:sales.africa@thevantagetradelink.in"
                >sales.africa@thevantagetradelink.in</a
              >
              <br />
              <a href="mailto:sales1@thevantagetradelink.in">
                sales1@thevantagetradelink.in</a
              >
            </li>
            <li>
              <i class="bx bxs-phone"></i>

              <a>+256 743 065676</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- End Footer Area -->

<!-- Footer bottom Area -->
<div class="footer-bottom">
  <div class="container">
    <div class="row">
      <div class="col">
        <p class="copyright">
          Copyright &copy; 2023 TVT Logistics India. All Rights Reserved.
        </p>
      </div>
      <div class="col">
        <p class="name">Website Designed & Developed By Kalpesh Patel.</p>
      </div>
    </div>
  </div>
</div>
<!-- End Footer bottom Area -->

<!-- Go Top -->
<div class="go-top">
  <i class="bx bx-chevrons-up"></i>
</div>
<!-- End Go Top -->
